<spr-block-title
	[first]="true"
	[showBack]="(sessionUser$ | async)?.isCoach"
	(goBack)="onChatGoBack()"
	backIcon="fas fa-times "
>
	{{ 'presentation.app.chat.title' | translate }}
</spr-block-title>
<div class="flex flex-auto flex-col relative items-stretch">
	<div class="font-medium p-3 uppercase p-color-primary text-lg">
		<span
			*ngFor="let participant of participants$ | async; let isFirst = first"
			class="title-participant"
		>
			<ng-container *ngIf="!isFirst">,&nbsp;</ng-container>
			{{ participant.name }}
		</span>
	</div>
	<div *ngIf="(sessionUser$ | async)?.isCoachee" class="pb-1 px-3">
		<ng-container *ngIf="userUsageStats$ | async as userUsageStats">
			<div class="flex mb-1 items-center flex-row">
				<div class="flex-auto font-medium text-xs p-color-text-secondary">
					{{ 'presentation.app.chat.credit.available' | translate }}
				</div>
				<div
					class="
						flex-auto flex-grow-0 flex-shrink-0
						font-medium
						text-xs
						p-color-text-secondary
					"
				>
					{{ userUsageStats.messagesLeft }}/{{ userUsageStats.messagesSentMax }}
				</div>
			</div>
			<p-progressBar
				[showValue]="false"
				[value]="
					(userUsageStats.messagesLeft / userUsageStats.messagesSentMax) * 100
				"
				styleClass="p-progressbar-positive"
			></p-progressBar>
		</ng-container>
	</div>
	<div class="flex-auto relative">
		<ng-scrollbar
			class="absolute w-full h-full top-0 left-0"
			track="vertical"
			visibility="hover"
		>
			<div *ngIf="sessionUser$ | async as user" class="p-3 space-y-3">
				<spr-chat-message
					*ngFor="let message of messages$ | async; trackBy: trackByMessage"
					[inOut]="(message.mine$ | async) ? 'left' : 'right'"
					[message]="message"
					(visioOpen)="onVisioOpen($event, user)"
				></spr-chat-message>
			</div>
		</ng-scrollbar>
	</div>
	<div *ngIf="visioUrl" class="relative aspect-w-1 aspect-h-1">
		<iframe
			[frameBorder]="false"
			[src]="visioUrl"
			class="absolute w-full h-full top-0 left-0 border-none"
			allow="camera;microphone"
		></iframe>
	</div>
	<form
		(ngSubmit)="onMessageSubmit()"
		class="
			flex
			items-center
			flex-row
			border-solid border-0 border-t-2
			p-border-color-component-background
		"
	>
		<button
			(click)="modulePanel.toggle($event)"
			class="
				p-button-primary-variant-transparent
				flex-auto flex-shrink-0 flex-grow-0
				text-lg
			"
			icon="spreeng spreeng-box"
			pButton
			type="button"
		></button>
		<button
			(click)="documentPanel.toggle($event)"
			class="
				p-button-primary-variant-transparent
				flex-auto flex-shrink-0 flex-grow-0
				text-lg
			"
			icon="spreeng spreeng-file"
			pButton
			type="button"
		></button>
		<!--
		<button
			(click)="visioUrl ? stopVisio() : startVisio()"
			class="
				p-button-primary-variant-transparent
				flex-auto flex-shrink-0 flex-grow-0
				text-lg
			"
			icon="fas {{ visioUrl ? 'fa-video-slash' : 'fa-video' }}"
			pButton
			type="button"
		></button>
		-->
		<input
			[ngModelOptions]="{ standalone: true }"
			[placeholder]="'presentation.app.chat.input.placeHolder' | translate"
			[(ngModel)]="message"
			class="flex-auto min-w-0 bg-transparent"
			pInputText
			type="text"
		/>
		<button
			class="
				p-button-primary-transparent
				flex-auto flex-shrink-0 flex-grow-0
				text-lg
			"
			icon="spreeng spreeng-arrow-right"
			pButton
			type="submit"
		></button>
	</form>
	<p-overlayPanel
		#modulePanel
		appendTo="body"
		styleClass="p-overlaypanel-left rounded"
	>
		<spr-chat-upload
			[isModule]="true"
			[overlayPanel]="modulePanel"
			[user]="user"
		></spr-chat-upload>
	</p-overlayPanel>
	<p-overlayPanel
		#documentPanel
		appendTo="body"
		styleClass="p-overlaypanel-left rounded"
	>
		<spr-chat-upload
			[overlayPanel]="documentPanel"
			[user]="user"
		></spr-chat-upload>
	</p-overlayPanel>
</div>
<button
	*ngIf="showToggleButton"
	(click)="onCollapseClick()"
	class="
		top-1/2
		-left-10
		w-10
		h-10
		absolute
		rounded-r-none
		flex-auto flex-shrink-0 flex-grow-0
		text-lg
	"
	icon="far fa-comments"
	pButton
></button>
